export const HANDLE_API_CREATE_COMBO = '@handleAPICalls/HANDLE_API_CREATE_COMBO';

